export const MEMBER_BONUS_SETTING_LIST = 'MEMBER_BONUS_SETTING_LIST';
export const MEMBER_BONUS_SETTING_SHOW = 'MEMBER_BONUS_SETTING_SHOW';
export const MEMBER_BONUS_SETTING_CREATE = 'MEMBER_BONUS_SETTING_CREATE';
export const MEMBER_BONUS_SETTING_UPDATE = 'MEMBER_BONUS_SETTING_UPDATE';